import React from "react";
import styles from "./Css/SeriesTopTen.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Scrollbar,
  A11y,
  Mousewheel,
  FreeMode,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useTrendingEbooks } from "../../hooks/useEbooksHooks";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Top10AudioSeries = () => {
  const { trendingEbooks, error, isLoading } = useTrendingEbooks();
  const navigate = useNavigate();

  // Render skeleton loading state
  const renderSkeletons = () => {
    return Array(5)
      .fill(0)
      .map((_, index) => (
        <SwiperSlide key={`skeleton-${index}`} className={styles.seriesSlide}>
          <div className={styles.seriesItem}>
            <div className={styles.rankContainer}>
              <Skeleton
                circle
                width={24}
                height={24}
                baseColor="#2a2a2a"
                highlightColor="#3a3a3a"
              />
            </div>
            <div className={styles.imageContainer}>
              <Skeleton
                height={180}
                width="100%"
                baseColor="#2a2a2a"
                highlightColor="#3a3a3a"
                style={{ borderRadius: "8px" }}
              />
            </div>
          </div>
        </SwiperSlide>
      ));
  };

  // If there's no data and it's not loading or has error, return null
  if (
    !isLoading &&
    !error &&
    (!trendingEbooks || trendingEbooks.length === 0)
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>Top 10 Short Stories</h2>

        <Swiper
          freeMode={{
            enabled: true,
            momentum: true,
            momentumRatio: 0.8,
            momentumVelocityRatio: 0.8,
            minimumVelocity: 0.02,
          }}
          modules={[Mousewheel, FreeMode, Navigation, Scrollbar, A11y]}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1.5,
            releaseOnEdges: true,
          }}
          speed={600}
          resistance={false}
          resistanceRatio={0}
          spaceBetween={15}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            320: {
              slidesPerView: 2.2,
              spaceBetween: 30,
            },
            480: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 3.5,
              spaceBetween: 40,
            },
            900: {
              slidesPerView: 4.5,
              spaceBetween: 50,
            },
            1200: {
              slidesPerView: 5.2,
              spaceBetween: 100,
            },
          }}
          className={styles.swiperContainer}
        >
          {isLoading ? (
            renderSkeletons()
          ) : error ? (
            <SwiperSlide className={styles.error}>
              Error loading content: {error}
            </SwiperSlide>
          ) : trendingEbooks.length === 0 ? (
            <SwiperSlide className={styles.noContent}>
              No stories available right now
            </SwiperSlide>
          ) : (
            trendingEbooks.map((book, index) => (
              <SwiperSlide key={book.id} className={styles.seriesSlide}>
                <div className={styles.seriesItem}>
                  <div className={styles.rankContainer}>
                    <span
                      onClick={() => navigate(`/book-detail/${book.slug}`)}
                      className={styles.rank}
                    >
                      {index + 1}
                    </span>
                  </div>
                  <div className={styles.imageContainer}>
                    <img
                      src={
                        book.cover_image_url_for_computer ||
                        book.cover_image_url_for_mbl
                      }
                      alt={book.title}
                      className={styles.seriesImage}
                      onClick={() => navigate(`/book-detail/${book.slug}`)}
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default Top10AudioSeries;
